import { MEDIUM_TYPE_PHYSICAL } from '@/prisma/schemaConstants'
import { ICart, IDelivery } from '../../cart/ICart'

export const splitDeliveries = (cartData?: ICart) => {
    const deliveries = cartData?.cart_contents?.deliveries ?? []
    const physicalDeliveries: IDelivery[] = []
    const virtualDeliveries: IDelivery[] = []

    deliveries.forEach((delivery) => {
        const isPhysical = delivery?.resolved_data?.delivery_options?.some(
            (option: any) =>
                option?.medium?.medium_type === MEDIUM_TYPE_PHYSICAL
        )

        if (isPhysical) {
            physicalDeliveries.push(delivery)
        } else {
            virtualDeliveries.push(delivery)
        }
    })

    return { physicalDeliveries, virtualDeliveries }
}
